import {Model} from "@/store/models/model"
import axios from '@/store/vue-axios'

export class ApiRoutesModel extends Model {
  static entity = 'api_routes'
  static primaryKey = 'key'
  static fields() {
    return {
      id: this.attr(null),
      key: this.attr(null),
      method: this.attr(null),
      route: this.attr(null),
      package: this.attr(null),
      permissions: this.attr(null),
      response: this.attr(null),
      is_public: this.attr(null),
      sort: this.attr(null),
      updated_at: this.attr(null),
      parameters: this.attr(null)
    }
  }
  static fetchApiRoutes(){
    const x = axios.get('/misc/docs/routes')
      .then(response=>{
        response.data.routes.map(el=>{
          ApiRoutesModel.insertOrUpdate({data:el})
        })})
      .catch(error=>error)
    return ApiRoutesModel.all()
  }
  static async createAxios(obj,params={}){
    const call = await axios({
      method: obj['method'],
      url: obj['route'],
      data: params
    })
    return call
  }
  static async createAxiosCall(routeKey,params={},url=''){
    let obj =  Object.assign({},ApiRoutesModel.find(routeKey))
    const call = await axios({
      method: obj['method'],
      url: url,
      data: params
    })
    return call
  }

  static async simpleAxios(obj){
    const call = await axios(obj)
    return call
  }

  static createUrlAxios(routeKey,params){
    let obj =  Object.assign({},ApiRoutesModel.find(routeKey))
    const string = obj.route
    const pattern = new RegExp("{[a-z]+}")
    function sprintf(format, ...args) {
      let i = 0;
      return format.replace(pattern, () => args[i++]);
    }
    const url = sprintf(string,params)
    console.log('CREATE URL', url)
    obj['route'] = url
    const res = this.createAxios(obj)
      .then(response => {
       ApiRoutesModel.update({
         where:obj.key,
         data:{response:response.data}})
      })
      .catch(error => error)
    return ApiRoutesModel.find(routeKey)
  }

  static getResponseData(key,params={},model=false, apiKey=false){
    const obj = ApiRoutesModel.getRoute(key)
    const res = this.createAxios(obj,params)
      .then(
        response=>{
          console.log('APIDATA PACKAGE CALLS:::',response.data)

          if(model !== false && apiKey !== false){
            model.insertOrUpdate({data:response.data[apiKey]})
          }
          else if(model !== false && apiKey === false ){
            model.insertOrUpdate({data:response.data})
          }
          else {
            ApiRoutesModel.update({
              where:obj.key,
              data:{response:response.data}
            })
          }
        }
      )
      .catch(
        error => error
      )

    return ApiRoutesModel.find(key)

  }
  //static createGetApiCalls(objlist=[], model, apiEntity){
  static createGetApiCalls(objlist=[]){
    const get_method_list = []
    const getlist = objlist.map(
      el => {
        el.parameters.length === 0 ? get_method_list.push(el) : undefined
      }
    )
    const axiosCalls = get_method_list.map(
      el => {
        axios[el.method](el.route)
          .then(response=>{
            console.log('APIMODEL RESPONSE', el , response)
            // model.insertOrUpdate({data:response.data[apiEntity]})
          })
          .catch(
            error => console.log('APIERROR',error)
          )

      }
    )
    return get_method_list
  }

  static getPackages(){
    const packages = []
    const p = ApiRoutesModel.all().map(
      el=> {!packages.includes(el.package) ? packages.push(el.package) : undefined}
    )
    return packages
  }
  static getRoutePackage(pack){
    const x = ApiRoutesModel.query().where('package', pack).get()
    console.log('GET ROUTE PACKAGE',x)
    return x
  }
  static getRoute(route_key){
    const x = ApiRoutesModel.query().where('key', route_key).get()
    console.log('GET ROUTE PACKAGE',x)
    return x[0]
  }
  static getPackageNames(pack){
      const x = {}
      const y = this.getRoutePackage(pack).map(el=>{x[el.key]=el})
      return x
  }
}

export default ApiRoutesModel



// WEBPACK FOOTER //
// ./src/store/models/layout/api_routes.js